/** Tự sinh bởi scripts/fetch-videos.mjs lúc build — không sửa tay. */
export default [];
